import { render, staticRenderFns } from "./KpiSetting.vue?vue&type=template&id=7794dde2&"
import script from "./KpiSetting.vue?vue&type=script&lang=ts&"
export * from "./KpiSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports